import React, { useState } from "react";
import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Pagination,
} from "@mui/material";
import { CiFilter } from "react-icons/ci";

const DatasetColumns = ({ data, securityclassification, sensitivity }) => {
  // Flatten the nested arrays into a single array
  const combinedData = data.flat();
  const itemsPerPage = 10;
  const [currentPage, setCurrentPage] = useState(1);

  const [securityClassification, setSecurityClassification] = useState(
    combinedData.map((item) => item?.securityClassification || "")
  );
  const [sensitivityValue, setSensitivityValue] = useState(
    combinedData.map((item) => item?.sensitivity || [])
  );

  const handleSecurityChange = (e, index) => {
    const newSecurityClassification = [...securityClassification];
    newSecurityClassification[index] = e.target.value;
    setSecurityClassification(newSecurityClassification);
  };

  const handleSensitivityChange = (e, index) => {
    const newSensitivityValue = [...sensitivityValue];
    newSensitivityValue[index] = e.target.value;
    setSensitivityValue(newSensitivityValue);
  };

  const handlePageChange = (event, value) => {
    setCurrentPage(value);
  };

  const paginatedData = combinedData.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  return (
    <div style={{ marginTop: "10px" }}>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          float: "right",
        }}
      >
        <FormControl
          sx={{ width: "14rem", marginBottom: "1.4rem" }}
          size="small"
        >
          <InputLabel id="demo-simple-select-label">
            <CiFilter size={18} /> Sort By
          </InputLabel>
          <Select
            labelId="demo-simple-select-label"
            id="demo-simple-select"
            label="Sort By"
          >
            <MenuItem value={10}>Ten</MenuItem>
            <MenuItem value={20}>Twenty</MenuItem>
            <MenuItem value={30}>Thirty</MenuItem>
          </Select>
        </FormControl>
      </div>
      <div style={{ height: "auto", width: "100%" }}>
        <TableContainer component={Paper}>
          <Table sx={{ minWidth: 700 }} aria-label="customized table">
            <TableHead sx={{ backgroundColor: "#F7F7F7" }}>
              <TableRow>
                <TableCell
                  sx={{ borderRight: "1px solid #dbdbdb" }}
                  align="center"
                >
                  Columns
                </TableCell>
                <TableCell
                  sx={{ borderRight: "1px solid #dbdbdb" }}
                  align="center"
                >
                  Tags
                </TableCell>
                <TableCell
                  sx={{ borderRight: "1px solid #dbdbdb" }}
                  align="center"
                >
                  Description
                </TableCell>
                <TableCell
                  sx={{ borderRight: "1px solid #dbdbdb" }}
                  align="center"
                >
                  Validation Rules
                </TableCell>
                <TableCell
                  sx={{ borderRight: "1px solid #dbdbdb" }}
                  align="center"
                >
                  Profilers
                </TableCell>
                <TableCell
                  sx={{ borderRight: "1px solid #dbdbdb" }}
                  align="center"
                >
                  Security Classification
                </TableCell>
                <TableCell
                  sx={{ borderRight: "1px solid #dbdbdb" }}
                  align="center"
                >
                  Sensitivity
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {paginatedData?.map((row, id) => (
                <TableRow key={id}>
                  <TableCell
                    component="th"
                    scope="row"
                    align="center"
                    sx={{
                      backgroundColor: "#F7F7F7",
                      borderRight: "1px solid #dbdbdb",
                    }}
                  >
                    {row?.name}
                  </TableCell>
                  <TableCell
                    align="center"
                    sx={{ borderRight: "1px solid #dbdbdb" }}
                  >
                    {row?.tags?.length > 0
                      ? row.tags.map((tag, idx) => (
                          <span key={idx}>{tag.label}</span>
                        ))
                      : "N/A"}
                  </TableCell>
                  <TableCell
                    align="center"
                    sx={{ borderRight: "1px solid #dbdbdb" }}
                  >
                    {row?.description || "N/A"}
                  </TableCell>
                  <TableCell
                    align="center"
                    sx={{ borderRight: "1px solid #dbdbdb" }}
                  >
                    {row?.col_datatype || "N/A"}
                  </TableCell>
                  <TableCell
                    align="center"
                    sx={{ borderRight: "1px solid #dbdbdb" }}
                  >
                    {row?.profilersdropdefaultValue.label || "N/A"}
                  </TableCell>
                  <TableCell
                    align="center"
                    style={{
                      borderRight: "1px solid #dbdbdb",
                    }}
                  >
                    {row?.securityClassification ? (
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                        }}
                      >
                        <p>{row.securityClassification}</p>
                        <Select
                          sx={{
                            boxShadow: "none",
                            ".MuiOutlinedInput-notchedOutline": { border: 0 },
                          }}
                          MenuProps={{
                            PaperProps: { sx: { maxHeight: 100, width: 100 } },
                          }}
                          value={securityClassification[id] || ""}
                          onChange={(e) => handleSecurityChange(e, id)}
                        >
                          {securityclassification?.map((item) => (
                            <MenuItem
                              key={item.value}
                              style={{ fontSize: "12px" }}
                              value={item.value}
                            >
                              {item.label}
                            </MenuItem>
                          ))}
                        </Select>
                      </div>
                    ) : (
                      "N/A"
                    )}
                  </TableCell>
                  <TableCell
                    align="center"
                    style={{
                      borderRight: "1px solid #d3d3d3",
                    }}
                  >
                    {row.sensitivity && row.sensitivity.length > 0 ? (
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                        }}
                      >
                        <p>{row.sensitivity[0]}</p>
                        <Select
                          sx={{
                            boxShadow: "none",
                            ".MuiOutlinedInput-notchedOutline": { border: 0 },
                          }}
                          MenuProps={{
                            PaperProps: { sx: { maxHeight: 100, width: 100 } },
                          }}
                          value={sensitivityValue[id] || ""}
                          onChange={(e) => handleSensitivityChange(e, id)}
                        >
                          {sensitivity?.map((item) => (
                            <MenuItem
                              key={item.value}
                              style={{ fontSize: "12px" }}
                              value={item.value}
                            >
                              {item.label}
                            </MenuItem>
                          ))}
                        </Select>
                      </div>
                    ) : (
                      "N/A"
                    )}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
        <br></br>
        <Pagination
          count={Math.ceil(combinedData.length / itemsPerPage)}
          page={currentPage}
          onChange={handlePageChange}
          variant="outlined"
          shape="rounded"
        />
      </div>
    </div>
  );
};

export default DatasetColumns;
